import { USER_LOGOUT } from "./types";

export const logout = () => {
  return {
    type: USER_LOGOUT,
    payload: null,
  };
};
